<section class="title-bar content-padding first-item">
    <div class="wrapper">
      <h2 class="left">Modelli SMS</h2>
      <br class="clear">
      <div class="right">
        <a routerLink="nuovo" class="ml-10">
            <span class="btn btn-white" id="addSmsTemplate">Aggiungi<i class="ml-10 fas fa-plus"></i></span>
        </a>
      </div>
    </div>
</section>
<section class="main-content wrapper content-padding">
    <!-- <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage">
    </app-pagination> -->
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form class="table-row-container row first-row filter">

        <div class="item data-col-10">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            ID</h4>
          <span class="data"></span>
        </div>

        <div class="item data-col-20">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            Tipo</h4>
          <span class="data">
            <!-- <input type="text"> -->
          </span>
        </div>

        <div class="item data-col-20">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            Descrizione</h4>
          <span class="data">
            <!-- <input type="text"> -->
          </span>
        </div>
        <div class="item data-col-5">
          <h4 class="title">Azioni</h4>
          <span class="data">
            <!-- <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
              <i class="fas fa-search"></i></button> -->
          </span>
        </div>
        <hr class="hr-clear">
      </form>
      <div class="table-row-container row" *ngFor="let smsTemplate of smsTemplates">
        <div class="item data-col-10">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            ID</h4>
          <div class="data data-id">
            <div>{{smsTemplate.id}}</div>
          </div>
        </div>

        <div class="item data-col-10">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            Tipo</h4>
          <div class="data">
            <div>{{smsTemplate.temp_type}}</div>
          </div>
        </div>

        <div class="item data-col-10">
          <h4 class="title">
            <i class="sort-icon fas"></i>
            Descrizione</h4>
          <div class="data">
            <div>{{smsTemplate.description}}</div>
          </div>
        </div>

        <div class="item data-col-5 ">
          <h4 class="title"> </h4>
          <span class="data saifu">
            <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top "  [routerLink]="['/smstemplates', smsTemplate.id, 'edit']">MODIFICA</button>
            &nbsp;
            <a (click)="$event.preventDefault(); delete(smsTemplate.id)">
              <span class="btn btn-red hvr-grow">Elimina<i class="ml-10 far fa-trash-alt"></i></span>
            </a>
          </span>
        </div>
      </div>
    </div>
</section>
